import React from 'react';
import { Frame } from './Frame';
import { software, compatibleSystems, exchangeFormats } from '../data/toolchain';
export function Toolchain() {
  return <section aria-labelledby="toolchain-title" data-id="element-555" data-mp="1r2vp7rb4dqrd">
      <Frame data-id="element-556" data-mp="1ccoa9lkbmpvf">
        <div className="grid md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]" data-id="element-557" data-mp="1cd7oosariw4p">
          <div className="px-5 py-10 md:px-6 md:py-16" data-id="element-558" data-mp="1ha6itauff32w">
            <h2 id="toolchain-title" className="font-display text-[30px] font-semibold leading-[1.08] tracking-[-0.035em] text-ink md:text-[40px]" data-id="element-559" data-mp="1h8vcb39ljh83">
              Konstruiert in Inventor.
              <br data-id="element-560" data-mp="1v2mneg2z795x" />
              Lesbar in jedem System.
            </h2>

            <ul className="mt-10 space-y-5" data-id="element-561" data-mp="1v4qqivt1w455">
              {software.map((tool, i) => <li key={tool.name} className="flex gap-4" data-id="element-562" data-mp="203k6cuvt878h" data-mpi={i}>
                  <span className={`mt-2 h-2 w-2 shrink-0 ${i === 0 ? 'bg-accent' : 'border border-ink'}`} aria-hidden="true" data-id="element-563" data-mp="jm69ir72l0l6" />
                  <div data-id="element-564" data-mp="1m1mo4k75fqn3">
                    <p className="text-[16px] font-medium text-ink" data-id="element-565" data-mp="1m2y1nbqeccre">{tool.name}</p>
                    <p className="text-[14px] text-ink/65" data-id="element-566" data-mp="1h4czh6rl3j0b">{tool.role}</p>
                  </div>
                </li>)}
            </ul>

            <p className="mt-10 font-mono text-[12px] leading-relaxed text-muted" data-id="element-567" data-mp="1v0q8dri1yc36">
              100 % kompatibel mit
              <br data-id="element-568" data-mp="2510llc437jic" />
              <span className="text-ink" data-id="element-569" data-mp="250h1boqysj15">{compatibleSystems.join(' · ')}</span>
            </p>
          </div>

          <div className="border-t border-line md:border-l md:border-t-0" data-id="element-570" data-mp="2014cwzkg33wg">
            <table className="w-full text-left" data-id="element-571" data-mp="2du3sf1k88y40">
              <caption className="sr-only" data-id="element-572" data-mp="2dsson1qs7qcw">Gelieferte Austauschformate</caption>
              <thead data-id="element-573" data-mp="29ta5aaelznc6">
                <tr className="border-b border-line font-mono text-[10px] uppercase tracking-[0.14em] text-muted" data-id="element-574" data-mp="29u3hhqwc751p">
                  <th scope="col" className="px-5 py-3 font-normal md:px-8" data-id="element-575" data-mp="2npfds2q553kq">Format</th>
                  <th scope="col" className="hidden border-l border-line px-5 py-3 font-normal sm:table-cell md:px-8" data-id="element-576" data-mp="2iqkk25qmxulu">Endung</th>
                  <th scope="col" className="border-l border-line px-5 py-3 font-normal md:px-8" data-id="element-577" data-mp="1kgkw0xkovcyg">Einsatz</th>
                </tr>
              </thead>
              <tbody data-id="element-578" data-mp="1pee5q0l7ap3h">
                {exchangeFormats.map(f => <tr key={f.name} className="border-b border-line last:border-b-0" data-id="element-579" data-mp="1u6xjoynsvm8t">
                    <th scope="row" className="px-5 py-5 font-display text-[18px] font-semibold tracking-[-0.02em] text-ink md:px-8" data-id="element-580" data-mp="1z6a2n8bjw964">
                      {f.name}
                    </th>
                    <td className="hidden border-l border-line px-5 py-5 font-mono text-[13px] text-ink/70 sm:table-cell md:px-8" data-id="element-581" data-mp="286or2gjta4du">
                      {f.extension}
                    </td>
                    <td className="border-l border-line px-5 py-5 text-[14px] text-ink/70 md:px-8" data-id="element-582" data-mp="dsnrftgftdcp">{f.use}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </Frame>
    </section>;
}